import { Stack, LinearProgress, Typography } from '@mui/material'
import React from 'react'

export const WaitingComprobationToken = () => {
    return (
        <Stack
            width='100%'
            height='100vh'
            justifyContent='center'
            alignItems='center'
            gap={5}
            sx={{backgroundImage: 'url(/fondo-login.png)', backgroundSize: '100% auto'}}
        >
            <img height={48} width={130} src="/logo-navbar.png" alt="logo faraday" />
            <Typography variant='h4' color='secondary'>Comprobando si hay sesión iniciada</Typography>
            <LinearProgress color='secondary' sx={{ marginTop: 5, width:'80%' }} />
        </Stack>
    )
}

